/** Port of Seattle Data Settlement — JSB media notice campaign tracking scripts. */
export function jsbScripts() {
    window.__portJsb = window.__portJsb || {};

    // Ensure gtag stubs exist (loader/configs live in index.js).
    window.dataLayer = window.dataLayer || [];
    window.gtag =
        window.gtag ||
        function gtag() {
            window.dataLayer.push(arguments);
        };

    const slug = window.location.pathname.replace(/^\/+|\/+$/g, "").toLowerCase();

    /**
     * Meta Pixel base init (pixel ID: 2028981387679953).
     * Fires once per session via deduplication guard.
     * TSV: "Paste the meta pixel into the bottom of the header section just above the </head> tag on every page."
     */
    if (!window.__portJsb.meta_pixel_loaded) {
        window.__portJsb.meta_pixel_loaded = true;

        !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
                n.callMethod
                    ? n.callMethod.apply(n, arguments)
                    : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = true;
            n.version = "2.0";
            n.queue = [];
            t = b.createElement(e);
            t.async = true;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

        window.fbq("init", "2028981387679953");
        window.fbq("track", "PageView");
    }

    /**
     * X (Twitter) — Universal website tag base code (pixel ID: o7f0u).
     * Loaded once per session via deduplication guard.
     * TSV: "Paste it before the </head> HTML tag of all pages on the website prior to adding event code."
     */
    if (!window.__portJsb.x_pixel_loaded) {
        window.__portJsb.x_pixel_loaded = true;

        !(function (e, t, n, s, u, a) {
            if (e.twq) return;
            s = e.twq = function () {
                s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
            };
            s.version = "1.1";
            s.queue = [];
            u = t.createElement(n);
            u.async = true;
            u.src = "https://static.ads-twitter.com/uwt.js";
            a = t.getElementsByTagName(n)[0];
            a.parentNode.insertBefore(u, a);
        })(window, document, "script");

        window.twq("config", "o7f0u");
    }

    /**
     * X (Twitter) — Landing Page View event (tw-o7f0u-rcxp4).
     * Fires once per session on every page, after the universal tag.
     * TSV: "Paste it before the </head> HTML tag of all pages on the website after adding the universal code."
     */
    if (!window.__portJsb.x_landing_page_view_fired) {
        window.__portJsb.x_landing_page_view_fired = true;
        if (typeof window.twq === "function") {
            window.twq("event", "tw-o7f0u-rcxp4", {});
        }
    }

    /**
     * Google Ads — Page Load conversion for the submit-claim page.
     * TSV: send_to 'AW-10839088199/S-HVCOTLw5ADEMe4vbAo'
     * "Paste it in between the <head></head> tags of the form page, right after the Google tag."
     */
    if (slug === "submit-claim") {
        if (!window.__portJsb.google_page_load_conversion_fired) {
            window.__portJsb.google_page_load_conversion_fired = true;
            window.gtag("event", "conversion", {
                send_to: "AW-10839088199/S-HVCOTLw5ADEMe4vbAo",
            });
        }
    }

    /**
     * Click-based conversion hooks on the submit-claim page.
     * - Google: gtag_report_conversion() fires AW-10839088199/-X6MCN7agYsbEMe4vbAo
     * - Meta: fbq('track', 'Lead') fires when the submit button is clicked
     * - X (Twitter): twq('event', 'tw-o7f0u-rcxp5') fires when the submit button is clicked
     *
     * TSV (Google Conversion): "Call gtag_report_conversion when someone clicks on the submit button of the form."
     * TSV (Facebook Lead): "Place pixel on the submit button of the form."
     * TSV (X Conversion): "Place pixel on the submit button of the claim's form."
     */
    if (slug === "submit-claim") {
        if (!window.__portJsb.google_submit_conversion_fn) {
            window.__portJsb.google_submit_conversion_fn = true;
            window.gtag_report_conversion = function (url) {
                const callback = function () {
                    if (typeof url !== "undefined") {
                        window.location = url;
                    }
                };
                window.gtag("event", "conversion", {
                    send_to: "AW-10839088199/-X6MCN7agYsbEMe4vbAo",
                    event_callback: callback,
                });
                return false;
            };
        }

        if (!window.__portJsb.submit_click_listener_loaded) {
            window.__portJsb.submit_click_listener_loaded = true;
            document.addEventListener(
                "click",
                (event) => {
                    const currentSlug = window.location.pathname
                        .replace(/^\/+|\/+$/g, "")
                        .toLowerCase();
                    if (currentSlug !== "submit-claim") return;

                    const submitButton = event.target?.closest?.("#submit-claim");
                    if (!submitButton || submitButton.disabled) return;

                    if (!window.__portJsb.google_submit_conversion_fired) {
                        window.__portJsb.google_submit_conversion_fired = true;
                        if (typeof window.gtag_report_conversion === "function") {
                            window.gtag_report_conversion();
                        } else {
                            window.gtag("event", "conversion", {
                                send_to: "AW-10839088199/-X6MCN7agYsbEMe4vbAo",
                            });
                        }
                    }

                    if (!window.__portJsb.meta_lead_fired) {
                        window.__portJsb.meta_lead_fired = true;
                        if (typeof window.fbq === "function") {
                            window.fbq("track", "Lead");
                        }
                    }

                    if (!window.__portJsb.x_conversion_fired) {
                        window.__portJsb.x_conversion_fired = true;
                        if (typeof window.twq === "function") {
                            window.twq("event", "tw-o7f0u-rcxp5", {
                                conversion_id: null, // unique ID for deduplication (e.g. order id '1a2b3c')
                            });
                        }
                    }
                },
                true
            );
        }
    }
}
